module.exports = __webpack_public_path__ + "img/red-btn.28579db2.svg";